import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/layout/Header/Header';
import GeolocationModal from './components/GeolocationModal'
import Main from './pages/Main/Main';
import Reservation from './pages/Reservation/Reservation';
import Menu from './pages/Menu/Menu';
import {default as Order} from './pages/Preorder/Preorder'
import Job from './pages/Job/Job';
import Bar from './pages/Bar/Bar'
import Footer from './components/layout/Footer/Footer';
import Karaoke from './pages/Karaoke/Karaoke';
import Dances from './pages/Dances/Dances';
import Lunch from './pages/Lunch/Lunch';
import Partner from './pages/Partner/Partner';
import Events from './pages/Events/Events';
import { RestaurantContext } from './providers/restaurant';
import { ReservationContext, PreorderContext } from './providers/reservation';
import { MenueContext } from './providers/menue';

import useTitle from './hooks/useTitle';
import { API_URL, SAVED_REST_ID_KEY } from './config/api';

import './App.scss';

import NewJob from './pages/NewJob/NewJob';
export { API_HOST, API_URL, SETTINGS_API_URL, SAVED_REST_ID_KEY } from './config/api'

function App() {
  // TODO: useMenu hook
  const [places, setPlaces] = useState()
  const [current, setCurrent] = useState(-1)
  const [reservationId, setReservationId] = useState()
  const [reservation, setReservation] = useState()
  const [preorderState, setPreorderState] = useState(
      {
          "guests": 1,
          
          "comment": "about",
          
          "menue": [
              // {
              //     "id": 416,
              //     "quantity": 2,
              //     "price": 159,
              //     "category": 2,
              // }
          ],
          showing: false,
          formed: false,
      }
  )

  const setReservationGuests = useCallback((v) => {
    setPreorderState(prev => ({...prev, guests: v}))
  }, [])
  const setReservationFIO = useCallback((v) => {
    setPreorderState(prev => ({...prev, fio: v}))
  }, [])
  const setReservationDate = useCallback((v) => {
    setPreorderState(prev => ({...prev, date: v}))
  }, [])
  const setReservationPhone = useCallback((v) => {
    setPreorderState(prev => ({...prev, phone: v}))
  }, [])

  useTitle()

  const [menue, setMenue] = useState()

  const location = useLocation()
  const feedbackPageParams = new URLSearchParams(location.search)
  const isStandaloneFeedbackPage =
    location.pathname === '/' &&
    feedbackPageParams.get('feedback') === '1' &&
    feedbackPageParams.get('page') === '1'

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'navigation',
        page: location.pathname + location.search,
      })
    }
  }, [location])

  useEffect(() => {
    let serverClosestId, serverClosestDistance
    fetch(API_URL + "/addresses").then(
      response => {
        const dd = response.headers.get('X-Doski-Distance');
        try {
          [serverClosestId, serverClosestDistance] = dd.split(';')[0].split(',')
          return response.json()
        } catch(e) {
          console.error("server geolocation error")
          return Promise.reject(e)
        }
      }
    ).then(
      content => {
        setPlaces(content)
        if (!localStorage.getItem(SAVED_REST_ID_KEY)) {
          console.log("geo from server:", serverClosestId, serverClosestDistance)
          setCurrent(content.findIndex(i => i.id === Number(serverClosestId)) || (content.length - 1))
        }
      }
    ).catch(
      e => {
        console.error(e)
      }
    )
  }, [])

  // useEffect(() => {
  //   let url = SETTINGS_API_URL + '/reservation_info'
  //     , p = places?.[current]
  //   if (p) {
  //     url += '?rest_id=' + p.id
  //   }
  //   fetch(url).then(
  //     response => response.json()
  //   ).then(
  //     content => {
  //       setReservation({...content})
  //     }
  //   )
  // }, [places, current])

  const [geolocationModal, setGeolocationModal] = useState(false)

  useEffect(() => {
    if (places) {
      const savedRestId = localStorage.getItem(SAVED_REST_ID_KEY)
      if (savedRestId) {
        const savedRestIdx = places?.findIndex(i => i.id === Number(savedRestId))
        if (savedRestIdx > -1) setCurrent(savedRestIdx)
      } else {
        setGeolocationModal(true)
      }
    }
  }, [places])

  const microdataBlock_ = useMemo(() => {
    const p = places?.[current]
    return p ? <div id="rest-microdata">
    <div itemScope itemType="http://schema.org/Organization">
      <p itemProp="name">DOSKI</p>
      <p itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
        <span itemProp="streetAddress">{p.address}</span>
        <span itemProp="postalCode">{p.postal_index}</span>
        <span itemProp="addressLocality">{p.city}</span>
      </p>
      <p itemProp="telephone">{p.phone}</p>
  </div></div> : null}, [places, current])

  return (
    <div className="App">
      <RestaurantContext.Provider value={{
        places, current, setCurrent
      }}>
      {!isStandaloneFeedbackPage && <Header />}
      <ReservationContext.Provider value={{
        id: reservationId,
        ...reservation,
        setReservation,
      }}>
      <PreorderContext.Provider value={{
        id: reservationId, setReservationId,
        setReservationGuests, setReservationFIO,
        setReservationDate, setReservationPhone,
        preorderState, setPreorderState,
      }}>
      <MenueContext.Provider value={{menue, setMenue}}>
      <Routes>
        <Route path="/" element={<Main />} />

        <Route path="/menu" element={<Menu />} />
        <Route path="/reservation" element={<Reservation />} />
        <Route path="/order" element={<Order />} />

        <Route path="/partner" element={<Partner />} />
        <Route path="/events" element={<Events />} />

        <Route path="/old-job" element={<Job />} />
        <Route path="/job" element={<NewJob />} />


        <Route path="/bar" element={<Bar />} />
        <Route path="/kitchen" element={<Lunch />} />
        <Route path="/dance" element={<Dances />} />
        <Route path="/karaoke" element={<Karaoke />} />
      </Routes>
      </MenueContext.Provider>
      </PreorderContext.Provider>
      </ReservationContext.Provider>
      {!isStandaloneFeedbackPage && <Footer />}

      {!isStandaloneFeedbackPage && <GeolocationModal onCancel={e => {
        setGeolocationModal(false)
      }} open={geolocationModal} />}
      {/* !!! геолокация */}
        

      </RestaurantContext.Provider>
      {microdataBlock_}
    </div>
  );
}

export default App;
